import Box from "@mui/material/Box";
import { grey, lime } from "@mui/material/colors";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import { GlobalState } from "context/GlobalContext";
import { useCallback, useEffect, useRef, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import parseErrMsgFromError from "utils/errorFunctions/parseErrorMessageFromError";

const defaultLimit = 20;

const DatagridWithApiPagination = ({
	tableRows = [],
	setTableRows,
	fetchTableRows = () => ({ result: [], totalRows: defaultLimit }),
	columns = [],
	handleRowClick,
	getRowId,
	recordsLimit = defaultLimit,polling = false, pollingTime = 60000
}) => {
	const { setSnackBar, snackBar, setSnackBarOpen, setLoadingOpen } = GlobalState();

	const [page, setPage] = useState(0);
	const [pageSize, setPageSize] = useState(recordsLimit);
	const [loading, setLoading] = useState(false);
	const [totalRecorsCount, setTotalRecordsCount] = useState(recordsLimit);

	const fetchDataBasedonPage = async (page, pageSize) => {
		try {
			setLoading(true);
			const { result, total_rows: totalRows } = await fetchTableRows(pageSize, page * pageSize);
			if (result?.length) {
				setTableRows(result);
				setTotalRecordsCount(totalRows ? totalRows : recordsLimit);
			} else throw new Error("Fetched 0 Table Rows");
		} catch (err) {
			console.error("Failed to fetch styles:", err);
			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, severity: "error", message: parseErrMsgFromError(err) });
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchDataBasedonPage(page, pageSize);
		if (polling) {
			const interval = setInterval(() => {fetchDataBasedonPage(page, pageSize)}, pollingTime);
	
			// Cleanup on component unmount
			return () => clearInterval(interval);
			// Set interval to call every 60 seconds
		}
	}, [page, pageSize]);
	return (
		<Stack spacing={2} margin="auto" width="100%" height="100%">
			<DataGrid
				rows={tableRows?.length ? tableRows : tableRows}
				// getRowId={(row) => row?.SITECODE}
				columns={columns}
				sx={{
					width: "100%",
					height: "100%",
					border: "none",
					"& .MuiDataGrid-row": {
						// borderBottom: "1px solid lightgray",
						cursor: "pointer",
						border: "none",
					},
					"& .MuiDataGrid-cell": {
						// borderBottom: "1px solid lightgray",
						padding: 0,
					},
					"& .MuiDataGrid-columnHeader": {
						cursor: "pointer",
						background: grey[300],
					},
				}}
				getRowId={(row) => (typeof getRowId === "function" ? getRowId(row) : row.id)}
				columnHeaderHeight={35}
				rowHeight={40}
				disableRowSelectionOnClick
				disableColumnMenu
				disableColumnFilter
				disableColumnSelector
				rowCount={totalRecorsCount}
				loading={loading}
				paginationMode="server"
				paginationModel={{ page, pageSize }}
				onPaginationModelChange={({ page, pageSize }) => {
					setPage(page);
					setPageSize(pageSize);
				}}
				onRowClick={({ row }) => typeof handleRowClick === "function" && handleRowClick(row)}
			/>
			{/* {loading && (
				<Box display="flex" sx={{ background: grey[400], borderRadius: 2, p: 1 }} alignItems="center">
					<Typography variant="body2" color={grey[900]}>
						Loading...{" "}
					</Typography>
					<CircularProgress size="18px" sx={{ transform: "scale(0.4)" }} />
				</Box>
			)} */}
		</Stack>
	);
};

export default DatagridWithApiPagination;
